<h3 *ngIf="langue.l == 'fr'">Les arbres</h3>
<h3 *ngIf="langue.l == 'en'">The skill trees</h3>

<p *ngIf="langue.l == 'fr'">
  <b>La structure</b><br>
  Les arbres de compétences prennent la forme de tableaux cadrillés avec des blocs de compétences.<br>
  Chaque bloc de compétence peut contenir entre un et trois niveaux de compétence, indiqué par le nombre d'étoiles dans le bloc.
  Le type d'avantage apporté par la compétence est inscrite en italique au dessus du nom de la compétence.<br>
  Les compétences sans étoiles dans leur bloc correspondent aux compétences fondamentales.
  Chaque compétence fondamentale possède exactement un niveau, et est la première compétence à prendre pour entrer dans l'arbre.<br>
  <br>
  <b>Le déplacement</b><br/>
  Au début, seul la ligne la plus haute dans l'arbre est accessible.<br/>
  En consommant un point de compétence (gagné en même temps qu'un niveau), un personnage peut acquérir une compétence accessible.
  Cela rend accessible les compétences directement en dessous et en diagonale vers le bas par rapport à cette nouvelle compétence acquise.
  Les "mouvements" horizontaux ne sont pas permis.<br/>
  Les compétences acquises sont donc possédées par le personnage et peuvent prendre effet.<br/>
</p>
<p *ngIf="langue.l == 'en'">

</p>

<h3 *ngIf="langue.l == 'fr'">Compétences d'attaque</h3>
<h3 *ngIf="langue.l == 'en'">Offensive skills</h3>

<p *ngIf="langue.l == 'fr'">
  <b>Les couleurs</b><br>
  Le vert correspond aux compétences liées aux armes de dextérité, pendant que les compétences rouges sont liées aux armes de force.<br>
  Il est impossible d'appliquer les effets d'une compétence verte à des arme de force (ou les effets d'une compétence rouge à des armes de dextérité)
  sans une règle explicite qui surpasserait ce statut par défaut (par exemple une connaissance).<br>
  Les compétences oranges sont accessibles aux deux types d'armes.<br>
  <br>
  <b>Débloquer les types d'armes</b><br/>
  Les premières compétences permettent l'utilisation respective d'armes simples de dextérité et d'armes simples de force.<br/>
  Avec 3 points investis dans l'arbre, l'utilisation des armes versatiles est débloquée.<br/>
  <br/>
  <b>Cibler</b><br/>
  cf <a routerLink="/system/attacking/targeting" routerLinkActive="activebutton">cibler</a> pour le tableau.<br/>
  Cibler est débloqué par les premiers points de compétences dans l'arbre d'attaque :
  Arme de dextérité et Armes de force (niveau 0).<br/>
  Lors d'une attaque avec une arme, il est <b>obligé</b> de cibler une partie du corps à attaquer (par défaut, un personnage cible le torse).
  Cibler applique un malus au toucher allant de -0 à -3.
  Les résultats d'avoir ciblé une attaque dépendent de la cible et du type de dégâts de l'attaque.<br/>
  <br/>
</p>
<p *ngIf="langue.l == 'en'">

</p>

<h3 *ngIf="langue.l == 'fr'">Compétences de défense</h3>
<h3 *ngIf="langue.l == 'en'">Defensive skills</h3>

<p *ngIf="langue.l == 'fr'">
  <b>Les couleurs</b><br>
  Le bleu turquoise représente les compétences réservées aux armures lourdes.
  Leurs effets ne peuvent être appliqués/activés que quand le personnage porte une armure lourde.<br>
  Il est nécessaire de prendre la compétence "Armure légère" avant "Armure lourde" puisque "Armure lourde" n'est pas sur la première ligne de l'arbre.<br>
</p>
<p *ngIf="langue.l == 'en'">

</p>

<h3 *ngIf="langue.l == 'fr'">Compétences de magie</h3>
<h3 *ngIf="langue.l == 'en'">Magic skills</h3>

<p *ngIf="langue.l == 'fr'">
    <b>Adaptation</b><br/>
    Peut passer un point d'un dé à un autre.<br/>
    Utilisable N fois / jour<br/>
    N = niveau maximal de compétence en magie<br/>
    Par exemple : le lancé donne 1-2-3-4.<br/>
    Situation 1, le sort requiert trois caractéristiques à 3,
    le mage peut alors décider le transférer un point du 4 vers le 2,
    pour transformer le résultat en 1-3-3-3.<br/>
    Situation 2, le sort requiert une caractéristique à 5,
    le mage peut alors décider le transférer un point du 2 (ou du 3) vers le 4,
    pour transformer le résultat en 1-1-3-5 (ou 1-2-2-5).<br/>
    Situation 3, le mage ne veut pas dépenser un point d'énergie supplémentaire,
    et il enlève un point d'un dé, pour passer la puissance totale à 9.<br/>
    <br/>
    <b>Investissement</b><br/>
    Investir des points dans cet arbre de compétence rend le lancé de sorts plus facile et moins coûteux.<br/>
    À partir de 3 points dans cet arbre, tous les coûts de lancé de sorts (pas des concentrations) sont diminués de 1 (min 0).
    Les sorts de niveau 1 sont donc gratuits.<br/>
    À partir de 5 points dans cet arbre, ils sont réduits de 1 additionnel, donc de 2 au total.
    Les sorts de niveau 2 sont donc gratuits.<br/>
    À partir de 8 points dans cet arbre, ils sont réduits de 1 additionnel, donc de 3 au total.
    Les sorts de niveau 3 sont donc gratuits.<br/>
    <br/>
    <b>Méditation</b><br/>
    La méditation est débloquée par le premier point de compétence de magie (niveau 0).<br/>
    cf état <a routerLink="/system/states" routerLinkActive="activebutton">en méditation</a><br>
    La méditation remplace le repos, et en 1 heure permet d'obtenir
    2 points d'énergie temporaire ainsi que de restorer 1 point d'énergie.
    Il est possible de ne méditer que 10 minutes et ainsi obtenir 1 point d'énergie temporaire,
    mais les résultats de cette pratique sont limités à une fois par heure.
    L'énergie temporaire ne peut être utilisée que pour la magie et disparait après un sommeil,
    ou 12 heures (le premier qui arrive).<br/>
    Méditer ne peut pas amener quelqu'un à posséder plus que 2 points d'énergie temporaire.<br/>
    Tout sort lancé et concentration gardée durant la méditation ne coûte aucun point d'énergie.<br/>
    <br/>
    <b>Conjuration</b><br/>
    cf <a routerLink="/system/magic/conjuration" routerLinkActive="activebutton">conjuration</a><br>
    <br/>
</p>
<p *ngIf="langue.l == 'en'">

</p>
